import { Navigate } from 'react-router-dom';
import { Center, Loader } from '@mantine/core';
import { useAuth } from '../context/AuthContext';

export function ProtectedRoute({ children }: { children: React.ReactNode }) {
  const { isAuthenticated, isLoading } = useAuth();

  if (isLoading) {
    return (
      <Center h="100vh">
        <Loader size="lg" color="haist" />
      </Center>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/shop/login" replace />;
  }

  return <>{children}</>;
}
